import { EquipmentListContext } from 'app/components/ReactContexts/equipmentListContext';
import { GlobalErrorContext } from 'app/components/ReactContexts/globalErrorContext';
import { LayoutContext } from 'app/components/ReactContexts/layoutContext';
import { MaintenanceHistoryContext } from 'app/components/ReactContexts/maintenanceHistoryContext';
import { getProcessedMaintenanceSchedule } from 'app/pages/TrackMaintenencePage/maintenanceUtils';
import { ic_nav_back as BackIcon } from 'app/widgets/SVGs';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLinkComponent } from './ArrowLinkComponent';
import { axiosInstance } from 'services/api';

interface Props {
  modelId?: string;
}

export function MaintenanceSchedules({ modelId }: Props) {
  const { t } = useTranslation();
  const { setClassNames, removeClassNames } = React.useContext(LayoutContext);
  const { addErrorModal } = React.useContext(GlobalErrorContext);
  React.useEffect(() => {
    let index: number = setClassNames('layout-grey');

    return () => removeClassNames(index);
  }, []);

  const { equipmentListData } = React.useContext(EquipmentListContext);
  const { maintenanceHistoryData, setMaintenanceHistoryData } =
    React.useContext(MaintenanceHistoryContext);

  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  const navigate = useNavigate();
  const location = useLocation();

  const isTrackMaintenance = location.pathname.includes('/trackMaintenance');
  const model = equipmentListData.selectedEquipment
    ? equipmentListData.selectedEquipment.model
    : modelId;

  React.useEffect(() => {
    (!maintenanceHistoryData.maintenanceIntervals ||
      maintenanceHistoryData.selectedModel != model) &&
      (async () => {
        setIsLoading(true);
        await axiosInstance
          .get(`/api/maintenanceSchedule/${model}`, {
            headers: {
              version: '2022_R03',
            },
          })
          .then(response => {
            const maintenanceIntervals = getProcessedMaintenanceSchedule(
              response.data,
              isTrackMaintenance,
            );

            setMaintenanceHistoryData({
              ...maintenanceHistoryData,
              maintenanceIntervals,
              selectedModel: model,
            });
          })
          .catch(err => addErrorModal())
          .finally(() => {
            setIsLoading(false);
          });
      })();
  }, []);

  return (
    <div className="layout-info-panel maintanance-schedule-panel">
      <div className="layout-info-panel_container">
        <span
          className="back-button back-button-on-layout fixed-on-desktop"
          onClick={() => navigate(-1)}
        >
          <BackIcon />
        </span>
        <div className="box-content">
          <div className="content-container">
            <div className="info-model ellipsis">
              {equipmentListData.selectedEquipment?.nickName || model}
            </div>
            <div className="layout-info-panel-header">
              <h1>{t('maintenance_schedules')}</h1>
            </div>
            <div className="info-panel-list-items mentainence-list scroll-area">
              {isLoading ? (
                <>
                  <div className="loading">
                    <div className="loading_text">{t('loading...')}</div>
                    <div className="loading_icon">
                      <div className="css-icon"></div>
                    </div>
                  </div>
                </>
              ) : (
                maintenanceHistoryData.maintenanceIntervals?.map(
                  (item, index) => (
                    <ArrowLinkComponent
                      key={index}
                      index={index}
                      scheduleItem={item}
                    />
                  ),
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
